import { memoize } from 'lodash/function'

export const getCurrentLocale = memoize(() => {
    return document.documentElement.getAttribute('lang') || 'de'
})

// reusable function to listen for clicks outside of dom element
export const onClickOutsideOf = (element, cb) => {
    const listener = (event) => {
        // use composedPath to reliably detect clicks outside
        const path = event.composedPath?.() || [];

        if (!path.includes(element)) {
            cb();
            removeListener();
        }
    };

    const removeListener = () => {
        window.removeEventListener('click', listener, true);
    };

    return {
        add: () => window.addEventListener('click', listener, true),
        remove: () => removeListener()
    };
};


export const getJSONScript = memoize((scriptId) => {
    const script = document.getElementById(scriptId)
    if (script && script.textContent) {
        try {
            return JSON.parse(script.textContent)
        } catch (e) {
            console.error(`Failed to parse JSON from script #${scriptId}:`, e)
            return undefined
        }
    }
    return undefined
})

export function getURLParameterByName(paramName) {
    const searchParams = new URLSearchParams(window.location.search)
    if (searchParams.has(paramName)) {
        return searchParams.get(paramName)
    }
    return undefined
}

export function sleep(duration) {
    return new Promise((resolve) =>
        window.setTimeout(() => resolve(true), duration)
    )
}
